// src/components/Subsection.jsx
import React from 'react';

export default function Subsection({ title, className = '', children }) {
  return (
    <div className={`rounded-xl border border-app p-4 ${className}`}>
      {title ? (
        <div className="mb-2 text-sm font-semibold text-app">
          {title}
        </div>
      ) : null}
      {children}
    </div>
  );
}
